function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
import get from 'lodash/get';
import { mapState } from 'vuex';
export default {
  props: {
    document: {
      type: Object,
      required: true
    },
    text: {
      type: Object,
      required: true
    },
    elements: {
      type: Array,
      required: true
    },
    moreElementsBefore: {
      type: Boolean,
      default: false
    },
    moreElementsAfter: {
      type: Boolean,
      default: false
    },
    matches: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    analysis: {
      type: Boolean,
      default: false
    },
    sourceText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visibleHeader: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    searchType: function searchType(s) {
      return s.api.query.type;
    }
  })), {}, {
    showSourceText: function showSourceText() {
      // Source text is optionally shown on top of the matching result
      var configuredSourceText = get(this.$ncsConfig.result.context[this.searchType], 'sourceText', false);
      return this.sourceText || configuredSourceText && this.matches.length > 0;
    },
    showAnalysis: function showAnalysis() {
      return this.searchType === 'tokens' && this.analysis;
    }
  }),
  methods: {
    elementContent: function elementContent(e) {
      if (e.visible === '\n' || e.unit === '\n' || e.token === '\n') {
        return '</br>';
      } else {
        return this.$ncsElementContent(e);
      }
    }
  }
};